import React, { useContext } from "react";
import "./Button.scss";
import StyleContext from "../../contexts/StyleContext";

export default function Button({ text, className, href, newTab }) {
  const { isDark } = useContext(StyleContext);

  const handleClick = (e) => {
    if (href && href.startsWith("#")) {
      e.preventDefault(); 
      const sectionId = href.substring(1); 
      
      // THE REUSED LOGIC
      if (sectionId === "contact") {
        window.scrollTo({
          top: document.documentElement.scrollHeight, // The absolute bottom
          behavior: "smooth",
        });
        return; 
      }
      
      // Normal section scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <div className={className}>
      <a 
        className={`main-button ${isDark ? "dark-mode" : ""}`}
        href={href} 
        target={newTab ? "_blank" : undefined} 
        rel={newTab ? "noopener noreferrer" : undefined}
        onClick={handleClick}
      >
        {text}
      </a>
    </div>
  );
}
